import { Tooltip } from '@mui/material';
import { useState, useRef } from 'react';

export default function ActionButton({
    icon = null,
    text = '',
    onClick = () => {},
    tooltipText = '',
    disabled = false,
    loading = false,
    className = '',
    textClass = 'text-center',
    htmlType = 'button',
    dataE2e,
    iconPosition = 'start',
    ariaExpanded = '',
    ref = ''
}) {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const buttonRef = useRef(ref || null);

    const handleClick = e => {
        if (tooltipText && window.innerWidth <= 768) {
            e.preventDefault();
            setTooltipOpen(true);
            setTimeout(() => setTooltipOpen(false), 1500);
            return;
        }
        onClick?.(e);
    };

    return (
        <Tooltip
            title={tooltipText}
            placement="top"
            arrow
            open={window.innerWidth <= 768 ? tooltipOpen : undefined}
            disableFocusListener={window.innerWidth <= 768}
            disableHoverListener={window.innerWidth <= 768}
            disableTouchListener={window.innerWidth <= 768}
            //   className='bg-[#000000] text-white'
        >
            <button
                ref={buttonRef}
                type={htmlType}
                disabled={disabled}
                data-e2e={dataE2e}
                onClick={handleClick}
                className={className}
                aria-label={text}
                aria-expanded={ariaExpanded}>
                {loading ? (
                    <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                ) : (
                    <>
                        {icon && iconPosition === 'start' && icon}
                        {text && <span className={textClass}>{text}</span>}
                        {icon && iconPosition === 'end' && icon}
                    </>
                )}
            </button>
        </Tooltip>
    );
}
